import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticatedHttpService } from '../authenticatedHttpService.service';
import { LogoutInfo } from '../auth.service';
import * as Sentry from '@sentry/angular';

@Injectable({ providedIn: 'root' })
export class SentryLogProvider {
    constructor(private http: AuthenticatedHttpService) { }

    init() {
        Sentry.init({
            dsn: environment.sentry.dsn,
        });
    }

    setUser(user: Sentry.User) {
        Sentry.setUser(user);
    }

    setDevice(device: any) {
        Sentry.setContext('device', device);
    }

    setEnvironment(env: any) {
        Sentry.setContext('environment', env);
    }

    reportSessionDrop(info: LogoutInfo): void {
        const userId = info.userId || this.http.userId || undefined;
        const email = info.email || this.http.getUserName() || undefined;
        const databaseIdentifier = info.databaseIdentifier || this.http.getUserDatabaseIdentifier() || undefined;

        Sentry.withScope(scope => {
            scope.setLevel('info');
            scope.setTag('topic', 'session-drop');
            scope.setTag('logout_reason', info.reason);

            if (userId || email) {
                scope.setUser({ id: userId, email });
            }

            scope.setExtra('sessionDrop', {
                reason: info.reason,
                userId: userId ?? null,
                email: email ?? null,
                databaseIdentifier: databaseIdentifier ?? null,
                occurredAt: new Date().toISOString(),
            });

            Sentry.captureMessage(`Session dropped: ${info.reason}`);
        });
    }

    logWithDebugLine(message: string, debugLine: number, withScreenshot?: boolean, topic?: string): void {
        this.log(`(${debugLine}): ` + message, withScreenshot, {}, topic);
    }

    logWithDebugLineAndObject(message: string, debugLine: number, withScreenshot?: boolean, extraData?: object, topic?: string): void {
        this.log(`(${debugLine}): ` + message, withScreenshot, extraData, topic);
    }

    log(message: string, withScreenshot?: boolean, extraData?: object, topic?: string): void {
        if (this.http.getUserName() === 'admin@rota.at') return;

        if (withScreenshot) {
            const root = document.querySelector('#app') as HTMLElement;
            if (!root) return;
        }
        else {
            Sentry.withScope(scope => {
                scope.setLevel('log');

                if (topic) {
                    scope.setTag('topic', topic);
                }

                if (extraData) {
                    try {
                        const serializedData = JSON.stringify(extraData);
                        scope.setExtra('extraData', serializedData);
                    } catch (error) {
                        console.error('Failed to serialize extraData:', error);
                    }
                }

                Sentry.captureMessage(message);
            });
        }
    }
}